module.exports = "https://www.gc-qa.gnp.com.mx/03f622da227eed0fdafeb5959e057988.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/group_3.svg
// module id = 8113
// module chunks = 0